import { FormId } from 'clickNgo/configs/formId'
import { getAccessToken } from 'cng-common/helpers/access'
import { proxy } from 'core/classes/helpers/UrlHelper'
import { HttpHeaders, HttpRequest } from 'core/classes/http'

interface IUploadLegalFile {
  type: string
}
export const createLegalFileRecord = async (records: IUploadLegalFile[]) => {
  const dataUrl = proxy(
    `/form/data-set-provider/v3/${FormId.LEGAL_ATTACHMENTS}/LegalAttachments/kendo/data`
  )

  const payload = { models: JSON.stringify(records) }
  const headers = new HttpHeaders()
  const token = getAccessToken()

  headers.add('Content-Type', 'application/json; charset=UTF-8')

  if (token) {
    headers.add('Authorization', `Bearer ${token}`)
  }

  const request = new HttpRequest(headers)
  const response = await request.post({ url: dataUrl, payload }).catch(() => {
    throw new Error('Request Failed')
  })
  return response['data'] || []
}
